import _ from 'lodash';

import { BODY_STYLE_KEYS, LIFESTYLE_PREFERENCES } from '@/constants';
import { priceRangeSliderMarks } from '@/components/discovery-questions-input/utils/price-range-slider-marks';
import { yearSliderMarks } from '@/constants/filter-constants';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'queryParams' implicitly has an 'any' type.
const hydrateFiltersStateFromUrl = (queryParams, filterActions) => {
  const searchParams = new URLSearchParams(queryParams);
  const year = searchParams.get('year');
  const price = searchParams.get('price');
  const safetyFeatures = searchParams.get('safetyFeatures');
  const bodyStyles = searchParams.get('bodyStyle');
  const makes = searchParams.get('makes');
  const starRatings = searchParams.get('starRating');
  const powerPlantType = searchParams.get('powerPlantType');

  const {
    addLifestyle,
    updateMakes,
    updateSafetyFeatures,
    updateSelectedBodyStyles,
    updateSelectedPriceRange,
    updateStarRatings,
    updateSelectedYearRange,
    updateUiSelectedYearRange,
    updateUiSelectedPriceRange,
    updatePowerTypes,
  } = filterActions;

  if (!queryParams) {
    return;
  }

  updateSelectedPriceRange(
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object is possibly 'undefined'.
    price ? price.split(',').map(Number) : [_.first(priceRangeSliderMarks).value, _.last(priceRangeSliderMarks).value]
  );

  updateUiSelectedPriceRange(
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object is possibly 'undefined'.
    price ? price.split(',').map(Number) : [_.first(priceRangeSliderMarks).value, _.last(priceRangeSliderMarks).value]
  );

  updateMakes(makes ? makes.split(',').map(String) : []);

  updateSafetyFeatures(safetyFeatures ? safetyFeatures.split(',').map((feature) => feature.toUpperCase()) : []);

  updateStarRatings(starRatings ? _.map(starRatings.split(','), (stars) => _.startCase(stars)) : []);

  updateSelectedBodyStyles(
    bodyStyles && !_.includes(bodyStyles, BODY_STYLE_KEYS.all) ? bodyStyles.split(',').map(String) : []
  );

  updateSelectedYearRange(
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object is possibly 'undefined'.
    year ? year.split(',').map(Number) : [_.first(yearSliderMarks).value, _.last(yearSliderMarks).value]
  );

  updateUiSelectedYearRange(
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object is possibly 'undefined'.
    year ? year.split(',').map(Number) : [_.first(yearSliderMarks).value, _.last(yearSliderMarks).value]
  );

  if (queryParams.pPlaterApproved) {
    addLifestyle(LIFESTYLE_PREFERENCES.pPlaterApproved);
  }

  if (queryParams.safeCarsForFamilies) {
    addLifestyle(LIFESTYLE_PREFERENCES.safeCarsForFamilies);
  }

  if (powerPlantType) {
    updatePowerTypes(powerPlantType.split(','));
  }
};

export default hydrateFiltersStateFromUrl;
